import React, { Component } from 'react'
import './App.css'

import Main from './containers/Main/Main'
import ErrorBoundary from './containers/ErrorBoundary/ErrorBoundary'
import { LoaderProvider } from './utils/LoadingContext'

class App extends Component {
    render() {
        return (
            <div className="App">
                <LoaderProvider>
                    <ErrorBoundary>
                        <Main />
                    </ErrorBoundary>
                </LoaderProvider>
            </div>
        )
    }
}

export default App
